import { render } from "./ImageViewPopup.vue?vue&type=template&id=12bcbb80&scoped=true&ts=true"
import script from "./ImageViewPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageViewPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ImageViewPopup.vue?vue&type=style&index=0&id=12bcbb80&lang=sass&scoped=true"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bcbb80"],['__file',"src/components/plant/ImageViewPopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12bcbb80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12bcbb80', __exports__)) {
    api.reload('12bcbb80', __exports__)
  }
  
  module.hot.accept("./ImageViewPopup.vue?vue&type=template&id=12bcbb80&scoped=true&ts=true", () => {
    api.rerender('12bcbb80', render)
  })

}


export default __exports__